import React, { Component } from "react";
import { Spin, Modal } from "antd";
import qs from "qs";
import FileSaver from "file-saver";
import dateFormat from "dateformat";
import moment from "moment";
import LeadsView from "./LeadsView";
import { getCampaignLeads, getPhysicalClinicList, downloadLeadsReport } from "../../services";
import { history, showErrorNotification, showSuccessNotification } from "../../helpers";

class LeadsContainer extends Component {
  state = {
    leads: [],
    pageNo: 1,
    perPage: 10,
    isProcessing: false,
    allRecords: 0,
    selectedRecord: null,
    clinics: [],
    filterParams: {
      clinicId: null,
      campaignId: null,
      startDate: null,
      endDate: null
    },
    searchText: null
  };

  componentDidMount() {
    // const params = this.props.location;
    this.fetchClinicsList();
    const params = qs.parse(this.props.location.search.slice(1));
    this.setState(
      {
        filterParams: { ...this.state.filterParams, campaignId: params?.clid }
      },
      () => {
        this.fetchLeads();
      }
    );
  }

  fetchClinicsList = searchText => {
    const { pageNo } = this.state;
    getPhysicalClinicList(pageNo, searchText || null, false).then(response => {
      this.setState({
        isProcessing: false
      });
      if (response.data.success) {
        const { clinics } = response.data.data;
        this.setState({
          clinics
        });
      } else {
        this.setState({
          clinics: []
        });
      }
    });
  };

  fetchLeads = () => {
    const { pageNo, perPage, filterParams, searchText } = this.state;
    this.setState({ isProcessing: true });
    getCampaignLeads(pageNo, perPage, filterParams, searchText).then(response => {
      this.setState({ isProcessing: false });
      if (response?.data?.data?.length > 0) {
        const leads = [];
        response.data.data.map(obj => {
          leads.push(obj.attributes);
        });
        this.setState({
          allRecords: response.data.meta.total_records,
          leads
        });
      } else {
        this.setState({ leads: [], allRecords: 0 });
      }
    });
  };

  onPageChange = page => {
    this.setState({ pageNo: page, leads: [] }, () => {
      this.fetchLeads();
    });
  };

  handleChangePageSizeChange = (current, size) => {
    this.setState({ perPage: size, pageNo: 1 }, () => {
      this.fetchLeads();
    });
  };

  handleSelectClinic = (clinicId = null) => {
    this.setState(
      { filterParams: { ...this.state.filterParams, clinicId: clinicId } },
      () => {
        this.fetchLeads();
      }
    );
  };

  gotoCampaigns = () => {
    history.push("/ad-campaigns");
  }

  /**
   * @function handleSearchText
   * @description This function get called when clicked on search icon
   */
  handleSearchText = e => {
    this.setState({ searchText: e.target.value });
  };

  /**
   * @function handleSearch
   * @description This function get called when clicked on pres button
   */
  handleSearch = () => {
    this.setState({ pageNo: 1, leads: [] }, () => {
      this.fetchLeads();
    });
  };

  handleExportLeads = () => {
    const { filterParams, searchText } = this.state;
    this.setState({ isProcessing: true });
    const todayDate = dateFormat(new Date(), "dd mmm yyyy");
    let fileName = `leads ${new Date().getTime()} ${todayDate}`;
    fileName = fileName.replace(/ /g,"_");

    const params = {
      campaignId: filterParams?.campaignId,
      clinicId: filterParams?.clinicId,
      startTime: filterParams?.startDate,
      endTime: filterParams?.endDate,
      searchText
    }
    
    downloadLeadsReport(params)
      .then(res => {
        this.setState({ isProcessing: false });

        const blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });

        showSuccessNotification("Leads data downloaded successfully")
        FileSaver.saveAs(blob, `${fileName}`);
      })
      .catch(() => {
        showErrorNotification("Error in downloading leads data");
        this.setState({
          isProcessing: false,
        });
      });
  };

  onDateFilterSelect = (date) => {
    const dateToday = moment(new Date()).format("YYYY-MM-DD");
    if (date?.length > 0) {
      const startDate = date[0] || dateToday;
      const endDate = date[1] || dateToday;
      this.setState({ filterParams: { ...this.state.filterParams, startDate, endDate } }, () => {
        this.fetchLeads();
      });
    } else {
      this.setState(
        { filterParams: { ...this.state.filterParams, startDate: null, endDate: null } },
        () => {
          this.fetchLeads();
        }
      );
    }
  };

  render() {
    const {
      isProcessing,
      leads,
      allRecords,
      pageNo,
      perPage,
      clinics,
      filterParams,
      searchText
    } = this.state;
    return (
      <Spin spinning={isProcessing}>
        <LeadsView
          leads={leads}
          allRecords={allRecords}
          pageNo={pageNo}
          perPage={perPage}
          onPageChange={this.onPageChange}
          handleChangePageSizeChange={this.handleChangePageSizeChange}
          clinics={clinics}
          fetchClinicsList={this.fetchClinicsList}
          handleSelectClinic={this.handleSelectClinic}
          gotoCampaigns={this.gotoCampaigns}
          filterParams={filterParams}
          searchText={searchText}
          handleSearchText={this.handleSearchText}
          handleSearch={this.handleSearch}
          handleExportLeads={this.handleExportLeads}
          onDateFilterSelect={this.onDateFilterSelect}
        />
      </Spin>
    );
  }
}

export default LeadsContainer;
